"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePixelResponseToJSON = exports.UpdatePixelResponseFromJSONTyped = exports.UpdatePixelResponseFromJSON = exports.instanceOfUpdatePixelResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdatePixelResponse interface.
 */
function instanceOfUpdatePixelResponse(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
exports.instanceOfUpdatePixelResponse = instanceOfUpdatePixelResponse;
function UpdatePixelResponseFromJSON(json) {
    return UpdatePixelResponseFromJSONTyped(json, false);
}
exports.UpdatePixelResponseFromJSON = UpdatePixelResponseFromJSON;
function UpdatePixelResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'domain': !(0, runtime_1.exists)(json, 'domain') ? undefined : json['domain'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
    };
}
exports.UpdatePixelResponseFromJSONTyped = UpdatePixelResponseFromJSONTyped;
function UpdatePixelResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'domain': value.domain,
        'name': value.name,
    };
}
exports.UpdatePixelResponseToJSON = UpdatePixelResponseToJSON;
